import { Building2, User } from "lucide-react";
import { logoUrl } from "@/lib/empresa";
import { fotoUrl } from "@/lib/user";

const LAVENDER_BOX = "rounded-xl border border-[hsl(var(--brand-border))] bg-[hsl(var(--brand-muted))] shadow-sm";
const LOGO_BOX = "flex shrink-0 items-center justify-center overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-[hsl(var(--brand-border))]";

export default function EmpresaBrand({
  empresa,
  compact = false,
  hideNombre = false,
  subtitle = null,
  detalle = null,
  usuario = null,
  fotoCacheKey = null,
}) {
  const logo = logoUrl(empresa);
  const foto = fotoUrl(usuario, fotoCacheKey);
  const avatarUrl = foto || logo;
  const nombre = empresa?.nombre || "Ventura HR";

  if (compact) {
    return (
      <div className={`flex min-w-0 items-center gap-2.5 px-2 py-1.5 ${LAVENDER_BOX}`}>
        <div className={`${LOGO_BOX} h-9 w-9`}>
          {avatarUrl ? (
            <img src={avatarUrl} alt="" className="h-full w-full object-cover" />
          ) : (
            <Building2 className="h-4 w-4 text-[hsl(var(--brand))]" strokeWidth={1.5} />
          )}
        </div>
        <p className="truncate text-sm font-semibold leading-tight text-zinc-900 dark:text-zinc-100">{nombre}</p>
      </div>
    );
  }

  return (
    <div className={`p-3 ${LAVENDER_BOX}`}>
      <div className="flex items-start gap-3">
        <div className={`${LOGO_BOX} h-12 w-12`}>
          {avatarUrl ? (
            <img src={avatarUrl} alt="" className="h-full w-full object-cover" />
          ) : foto ? (
            <User className="h-6 w-6 text-[hsl(var(--brand))]" strokeWidth={1.5} />
          ) : (
            <Building2 className="h-6 w-6 text-[hsl(var(--brand))]" strokeWidth={1.5} />
          )}
        </div>
        <div className="min-w-0 flex-1">
          {!hideNombre && (
            <p className="font-display text-base font-semibold leading-tight tracking-tight text-zinc-900 dark:text-zinc-100">
              {nombre}
            </p>
          )}
          {subtitle && (
            <p
              className={
                hideNombre
                  ? "font-display text-base font-semibold leading-tight tracking-tight text-zinc-900 dark:text-zinc-100"
                  : "mt-0.5 text-sm leading-tight text-zinc-600 dark:text-zinc-400"
              }
            >
              {subtitle}
            </p>
          )}
          {detalle}
        </div>
      </div>
    </div>
  );
}
